import {
  Component,
  computed,
  inject,
  InjectionToken,
  OnInit,
  output,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import {
  DynamicFormField,
  fieldGroup,
  formBuilder,
  select,
} from '@kinet-open-network/client/core/forms/ui';
import {
  AutomationRuleType,
  automationRuleTypeOptions,
  createEnumList,
  IAutomationRule,
} from '@kinet-open-network/shared/data-access/model';
import { FormlyModule } from '@ngx-formly/core';
import { AutomationConditionRuleContainerComponent } from '../automation-condition-rule-container.component';

export const RULE_TEMPLATE = `
  <formly-form 
    [fields]="fields"
    [model]="model"
    (modelChange)="handleModelChange($event)"
  />
`;

export const RULE_TOKEN = new InjectionToken<IAutomationRule>(
  'Automation Rule',
);

@Component({
  selector: 'kon-automation-rule',
  imports: [FormlyModule],
  template: RULE_TEMPLATE,
})
export class RuleComponent implements OnInit {
  private container = inject(AutomationConditionRuleContainerComponent);
  readonly rule = inject(RULE_TOKEN);

  ruleChange = output<IAutomationRule>();

  protected ruleOptions = computed(() => {
    const enabledRules = this.container.enabledRules();

    return createEnumList(automationRuleTypeOptions).filter((option) =>
      enabledRules.includes(option.value as AutomationRuleType),
    );
  });

  protected ruleSelectField = select('rule', '')
    .options(toObservable(this.ruleOptions))
    .props({
      required: true,
    })
    .wrappers([]);

  fields: DynamicFormField[] = formBuilder(
    fieldGroup().fieldGroup([this.ruleSelectField]),
  );

  defaultModel: Partial<IAutomationRule> = {};

  model: Partial<IAutomationRule> = {};

  handleModelChange(data: Partial<IAutomationRule>) {
    this.ruleChange.emit({
      ...this.rule,
      ...data,
    });
  }

  ngOnInit(): void {
    this.model = {
      ...Object.entries(this.rule).reduce((acc, [key, value]) => {
        if (value !== undefined) {
          acc[key as keyof IAutomationRule] = value;
        }
        return acc;
      }, this.defaultModel),
    };
  }
}
